import React from 'react';
import { Button } from '@framework-controls/core';
import { strings } from 'src/localization';
import * as css from './ContactDealer.module.scss';
import classNames from 'classnames';

export interface Iprops {
    setDepartmentSpecs: (header: string) => void;
    label: string;
    sectionHeader: string;
    theme: string;
}

const DepartmentTile = (props: Iprops) => {
    let tileClass = classNames (
        css.tile,
        {
            [css.tileCadillac]: props.theme === 'cadillac',
            [css.tileFord]: props.theme === 'ford',
            [css.tileFont1Rem]: props.theme === 'honda' || props.theme === 'porsche',
            [css.tileIN]: props.theme === 'infiniti',
            [css.tileNissan]: props.theme === 'nissan',
            [css.tileMazda]: props.theme === 'mazda',
            [css.tileAcura]: props.theme === 'acura',
        },
    );

    if ('Contact ' + props.label === props.sectionHeader) {
        tileClass = classNames (
            css.tile,
            css.tileClicked,
            {
                [css.tileClickedCadillac]: props.theme === 'cadillac',
                [css.tileClickedFont1Rem]: props.theme === 'honda' || props.theme === 'porsche',
                [css.tileClickedHonda]: props.theme === 'honda',
                [css.tileClickedLexus]: props.theme === 'lexus',
                [css.tileClickedIN]: props.theme === 'infiniti',
                [css.tileClickedNissan]: props.theme === 'nissan',
                [css.tileClickedMazda]: props.theme === 'mazda',
                [css.tileClickedAcura]: props.theme === 'acura',
            },
        );
    }

    return (
        <div className={css.tileContainer}>
            <Button
                id={props.label}
                onClick={() => {
                    props.setDepartmentSpecs(`${strings.Contact} ${props.label}`);
                }}
                variant='contactUs'
            >
                <div
                    className={tileClass}
                >
                    {props.label}
                </div>
            </Button>
        </div>
    );
};

export default DepartmentTile;